import React from 'react'

import MessagePage from '../MessagePage'

const BrowserProductionBlocked: React.FC = () => (
  <MessagePage
    variant="error"
    title="Acesso pelo navegador não disponível"
    description="Por segurança, utilize o aplicativo Inter no celular para acessar esta funcionalidade."
    footer={<span aria-hidden />}
  />
)

export default BrowserProductionBlocked
